import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/daily-sharing/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/daily-sharing',
  name: 'daily_sharing',
  component: Index,
  meta: {
    title: '天天跳绳',
  },
}

export default [indexRoute]
